import { render, staticRenderFns } from "./yx.vue?vue&type=template&id=458c9e87&scoped=true&"
import script from "./yx.vue?vue&type=script&lang=js&"
export * from "./yx.vue?vue&type=script&lang=js&"
import style0 from "./yx.vue?vue&type=style&index=0&id=458c9e87&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c9e87",
  null
  
)

export default component.exports